<template>
    <div class="modal-overlay">
        <div class="modal-content">

            <div v-if="!selectedTool" class="select-tool">
                <h3>انتخاب روش افزودن تصویر</h3>
                <button class="btn btn-primary" @click="selectedTool = 'camera'">📷 دوربین</button>
                <button class="btn btn-success" @click="selectedTool = 'drawing'">🖍 قلم نوری</button>
            </div>

            <div v-else>
                <ModalHeader>
                    <template #actions>
                        <button class="modal-close-btn" @click="closeTool">✖</button>
                    </template>
                </ModalHeader>

                <CameraCapture v-if="selectedTool === 'camera'" :recordId="props.recordId" @confirm="handleConfirm"
                    @close="closeTool" />

                <DrawingCapture v-if="selectedTool === 'drawing'" :recordId="props.recordId" @confirm="handleConfirm"
                    @close="closeTool" />
            </div>

        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import CameraCapture from './CameraCapture.vue'
import DrawingCapture from './DrawingCapture.vue'
import ModalHeader from '@/components/ModalHeader.vue'

// eslint-disable-next-line no-undef
const props = defineProps({
    recordId: { type: Number, required: true }
})
// eslint-disable-next-line no-undef
const emit = defineEmits(['confirm', 'close'])

const selectedTool = ref(null)

function handleConfirm({ recordId, photos }) {
    emit('confirm', { recordId, photos })
    selectedTool.value = null
}

function closeTool() {
    selectedTool.value = null
    emit('close')
}
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100%;
    background-color: rgba(var(--text-color-secondary-rgb), 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    -webkit-backdrop-filter: saturate(180%) blur(5px) !important;
    backdrop-filter: saturate(180%) blur(5px) !important;
}

.modal-content {
    background-color: var(--background-color);
    padding: 0 20px 20px 20px;
    border-radius: 30px;
    width: auto;
    max-height: 90vh;
    max-width: 90vw;
    overflow-y: auto;
    position: relative;
    direction: rtl;
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin: 10px;
}

.select-tool {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
}

.btn {
    padding: 10px 20px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 16px;
}

.btn-primary {
    background: #007bff;
    color: #fff;
}

.btn-success {
    background: #1474f2;
    color: #fff;
}

.modal-close-btn {
    float: right;
    background: transparent;
    border: none;
    font-size: 18px;
    cursor: pointer;
}
</style>
